
import {
    GET_ADMIN_TICKETS,
    GET_ADMIN_TICKETS_SUCCESS,
    GET_ADMIN_TICKETS_FAIL,
    GET_ADMIN_TICKET_DETAIL,
    GET_ADMIN_TICKET_DETAIL_SUCCESS,
    GET_ADMIN_TICKET_DETAIL_FAIL,
    UPDATE_TICKET_STATUS,
    UPDATE_TICKET_STATUS_SUCCESS,
    UPDATE_TICKET_STATUS_FAIL,
    REPLY_TICKET,
    REPLY_TICKET_SUCCESS,
    REPLY_TICKET_FAIL,
} from "./actionTypes"

export const getAdminTickets = (params) => ({
    type: GET_ADMIN_TICKETS,
    payload: params,
})

export const getAdminTicketsSuccess = (tickets) => ({
    type: GET_ADMIN_TICKETS_SUCCESS,
    payload: tickets,
})

export const getAdminTicketsFail = (error) => ({
    type: GET_ADMIN_TICKETS_FAIL,
    payload: error,
})

export const getAdminTicketDetail = (id) => ({
    type: GET_ADMIN_TICKET_DETAIL,
    payload: id,
})

export const getAdminTicketDetailSuccess = (ticket) => ({
    type: GET_ADMIN_TICKET_DETAIL_SUCCESS,
    payload: ticket,
})

export const getAdminTicketDetailFail = (error) => ({
    type: GET_ADMIN_TICKET_DETAIL_FAIL,
    payload: error,
})

export const updateTicketStatus = (id, data) => ({
    type: UPDATE_TICKET_STATUS,
    payload: { id, data },
})

export const updateTicketStatusSuccess = (ticket) => ({
    type: UPDATE_TICKET_STATUS_SUCCESS,
    payload: ticket,
})

export const updateTicketStatusFail = (error) => ({
    type: UPDATE_TICKET_STATUS_FAIL,
    payload: error,
})

export const replyTicket = (id, data) => ({
    type: REPLY_TICKET,
    payload: { id, data },
})

export const replyTicketSuccess = (reply) => ({
    type: REPLY_TICKET_SUCCESS,
    payload: reply,
})

export const replyTicketFail = (error) => ({
    type: REPLY_TICKET_FAIL,
    payload: error,
})
